import api from '../api';

/**
 * @param {string} token
 * @param {string} namespace
 * @param {Object} personalData
 * @param {string} personalData.empresaId
 * @param {string} personalData.nomeUsuario
 * @param {string} personalData.cpf
 * @param {string} personalData.telefone
 * @param {string} personalData.whatsapp
 * @param {string} personalData.email
 * @param {string} personalData.aceiteType
 * @param {string} personalData.empresaCnpj
 * @param {string} personalData.nomeCompleto
 * @param {string|null} personalData.produtoInteresse
 */
export const aceitar = async (type, token, namespace, personalData, originCoop) => {
  const url = '/api/cotacoes/aceite';
  return api.post(url, {
    ...personalData,
    key: token,
    namespace,
    aceiteType: type,
  }, {
    originCoop,
  });
};

/**
 * @param {number} type
 * @param {string} token
 * @param {string} namespace
 */
export const cancelar = async (type, token, namespace, originCoop) => {
  const url = '/api/cotacoes/aceite/cancel';
  return api.post(url, {
    key: token,
    namespace,
    aceiteType: type,
  }, {
    originCoop,
  });
};

/**
 * @param {string} token
 * @param {number} type
 * @returns {Promise<boolean>}
 */
export const buscarAceite = async (token, type, originCoop) => {
  const url = `/api/cotacoes/${token}/aceite/${type}`;

  try {
    const response = await api.get(url, { originCoop });
    if (response) {
      return response.compartilhou;
    }

    return false;
  } catch (error) {
    return false;
  }
};

export const tiposAceite = {
  seguros: 1,
  consigaMais: 2,
  peopleClub: 3,
};
